import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditTrailPanel = ({ activities }) => {
  const getActivityIcon = (type) => {
    const icons = {
      generated: 'Plus',
      verified: 'CheckCircle',
      modified: 'Edit',
      deleted: 'Trash2',
      exported: 'Download',
      approved: 'Shield'
    };
    return icons?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colors = {
      generated: 'text-success bg-success/10',
      verified: 'text-primary bg-primary/10',
      modified: 'text-warning bg-warning/10',
      deleted: 'text-error bg-error/10',
      exported: 'text-accent bg-accent/10',
      approved: 'text-primary bg-primary/10'
    };
    return colors?.[type] || 'text-muted-foreground bg-muted';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Audit-Trail</h3>
        <button className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-primary hover:bg-primary/10 rounded-md transition-colors">
          <Icon name="Download" size={16} />
          <span>Exportieren</span>
        </button>
      </div>
      <div className="space-y-4">
        {activities?.map((activity, index) => (
          <div key={activity?.id} className="relative">
            {index !== activities?.length - 1 && (
              <div className="absolute left-5 top-12 bottom-0 w-px bg-border" />
            )}
            <div className="flex gap-4">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${getActivityColor(activity?.type)}`}>
                <Icon name={getActivityIcon(activity?.type)} size={18} />
              </div>
              <div className="flex-1 pb-6">
                <div className="flex items-start justify-between gap-4 mb-2">
                  <div>
                    <h4 className="text-sm font-semibold text-foreground">{activity?.action}</h4>
                    <p className="text-xs text-muted-foreground mt-1">{activity?.description}</p>
                  </div>
                  <span className="text-xs text-muted-foreground whitespace-nowrap">{activity?.timestamp}</span>
                </div>
                <div className="flex items-center gap-4 mt-3">
                  <div className="flex items-center gap-2">
                    <Icon name="User" size={14} color="var(--color-muted-foreground)" />
                    <span className="text-xs text-muted-foreground">{activity?.user}</span>
                  </div>
                  {activity?.clientId && (
                    <>
                      <span className="text-muted-foreground">•</span>
                      <div className="flex items-center gap-2">
                        <Icon name="Hash" size={14} color="var(--color-muted-foreground)" />
                        <span className="text-xs font-mono text-muted-foreground">{activity?.clientId}</span>
                      </div>
                    </>
                  )}
                  {activity?.ipAddress && (
                    <>
                      <span className="text-muted-foreground">•</span>
                      <div className="flex items-center gap-2">
                        <Icon name="Globe" size={14} color="var(--color-muted-foreground)" />
                        <span className="text-xs text-muted-foreground">{activity?.ipAddress}</span>
                      </div>
                    </>
                  )}
                </div>
                {activity?.notes && (
                  <div className="mt-3 p-3 bg-muted/50 rounded-lg">
                    <p className="text-xs text-foreground">{activity?.notes}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AuditTrailPanel;